import { unitMapping } from 'lib/style';

type Props = {
  size?: keyof typeof unitMapping;
  color?: string;
};
export const Clock = ({ size = 2, color = '#F0CE1D' }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    style={{ width: unitMapping[size], height: unitMapping[size] }}
    viewBox="0 0 12 12"
    fill="none"
  >
    <g clipPath="url(#clip0_17050_16000)">
      <path
        d="M5.71814 0.531982C2.82548 0.678653 0.524984 3.07069 0.52478 5.99976L0.531616 6.28198C0.678288 9.17478 3.07112 11.4753 6.00037 11.4753L6.28162 11.4685C9.08116 11.3267 11.3262 9.0815 11.4681 6.28198L11.475 5.99976C11.4748 2.97631 9.02382 0.525358 6.00037 0.525146L5.71814 0.531982ZM6.00037 1.72534C8.36107 1.72555 10.2746 3.63905 10.2748 5.99976C10.2748 8.36064 8.3612 10.2749 6.00037 10.2751C3.63935 10.2751 1.72498 8.36077 1.72498 5.99976C1.72519 3.63892 3.63948 1.72534 6.00037 1.72534Z"
        fill={color}
      />
      <path
        d="M5.72984 6.28527V6.88527H5.12984L5.12984 6.28527H5.72984ZM5.72984 6.28527V5.68527H8.40003V6.28527V6.88527H5.72984V6.28527ZM5.72984 6.28527H5.12984V3.30066L5.72984 3.30066L6.32984 3.30066V6.28527H5.72984Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_17050_16000">
        <rect width="12" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
